export enum RtxRegion {
	NanpUs48 = '0',
	NanpCanada = '2',
	NanpUsAlaska = '3',
	NanpCaribbean = '4',
	NanpUsHawaii = '6',
	Nanp9YY = '9',
	NanpNonGeographic = 'B',
	NanpPacific = 'C',
	NanpUnknown = 'X'
}

export const RtxJurisdiction = {
	1: 'IDDD: National',
	5: 'IDDD: International',
	9: 'IDDD: Unknown',
	101: 'USA: Interstate',
	102: 'USA: Intrastate',
	103: 'USA: NANP',
	104: 'USA: Toll-Free',
	105: 'USA: International',
	109: 'USA: Unknown'
} as const;
export type RtxJurisdiction =
	(typeof RtxJurisdiction)[keyof typeof RtxJurisdiction];
